const OrderData = [
    {
        id: '#12354781',
        amount: '$22',
        date: 'Jul 11, 2019',
        paymenticon: 'fa-cc-amex',
        name: 'Lasse C. Overgaard',
        status: 'Paid'
    },
    {
        id: '#12365474',
        amount: '$1,541',
        date: 'Jul 10, 2019',
        paymenticon: 'fa-cc-mastercard',
        name: 'Johan E. Knudsen',
        status: 'Chargeback'
    },
    {
        id: '#23145216',
        amount: '$22',
        date: 'Jul 11, 2019',
        paymenticon: 'fa-cc-amex',
        name: 'Lasse C. Overgaard',
        status: 'Paid'
    },
    {
        id: '#24514781',
        amount: '$254',
        date: 'Jul 08, 2019',
        paymenticon: 'fa-cc-amex',
        name: 'Nikolaj S. Henriksen',
        status: 'Paid'
    },
    {
        id: '#32147851',
        amount: '$421',
        date: 'Jul 08, 2019',
        paymenticon: 'fa-cc-amex',
        name: 'Nikolaj S. Henriksen',
        status: 'Paid'
    },
    {
        id: '#32569874',
        amount: '$54',
        date: 'Jul 09, 2019',
        paymenticon: 'fa-cc-visa',
        name: 'Herbert C. Patton',
        status: 'Paid'
    },
    {
        id: '#45123698',
        amount: '$241',
        date: 'July 14, 2019',
        paymenticon: 'fa-cc-paypal',
        name: 'Nikolaj S. Henriksen',
        status: 'Refund'
    },
    {
        id: '#50025441',
        amount: '$845',
        date: 'Jul 08, 2019',
        paymenticon: 'fa-cc-discover',
        name: 'Mathias N. Klausen',
        status: 'Refund'
    },
    {
        id: '#52140300',
        amount: '$45',
        date: 'Jul 20, 2019',
        paymenticon: 'fa-cc-visa',
        name: 'Herbert C. Patton',
        status: 'Paid'
    },
    {
        id: '#52146321',
        amount: '$652',
        date: 'Jul 02, 2019',
        paymenticon: 'fa-cc-mastercard',
        name: 'Lasse C. Overgaard',
        status: 'Paid'
    }
];

export { OrderData };

